import { setTheme } from "@/helpers";
import { BuilderBlockProps, Theme } from "@/types";
import { FC, PropsWithChildren } from "react";
import cn from "classnames";
import styles from "./Table.module.css";

export type TableProps = {
  ariaLabel: string;
  theme?: Theme;
  variant?: "regular" | "lined";
} & Partial<BuilderBlockProps>;

const Table: FC<PropsWithChildren<TableProps>> = ({
  children,
  ariaLabel,
  theme,
  attributes,
  variant = "regular",
}) => {
  const variantClass = variant === "regular" ? styles.regular : styles.lined;
  return (
    <div
      {...setTheme(theme)}
      {...attributes}
      className={cn(styles.scroller, attributes?.className)}
    >
      <table aria-label={ariaLabel} className={variantClass}>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default Table;
